<template>
  <el-dialog class="edit"
             :visible.sync="editVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1200px"
             :title="$t('platformList.add.dialogTitle_edit')"
             :modal-append-to-body="false"
             append-to-body>
    <div class="container"
         v-loading="loading">
      <el-form ref="editForm"
               :model="editForm"
               label-width="100px" @keydown.enter.native.prevent>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('platformList.add.name')"
                          :rules="[{ required: true, message: `${$t('platformList.add.inputPlaceholder')}${$t('platformList.add.name')}` }]"
                          prop="name"
                          size="small"
                          >
              <el-input clearable
                        :placeholder="`${$t('platformList.add.inputPlaceholder')}${$t('platformList.add.name')}`"
                        size="small"
                        v-model="editForm.name">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('platformList.add.code')"
                          size="small">
              <el-input clearable
                        :placeholder="`${$t('platformList.add.inputPlaceholder')}${$t('platformList.add.code')}`"
                        size="small"
                        v-model="editForm.code">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('platformList.add.url')"
                          size="small">
              <el-input clearable
                        :placeholder="`${$t('platformList.add.inputPlaceholder')}${$t('platformList.add.url')}`"
                        size="small"
                        v-model="editForm.url">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('platformList.add.sort')"
                          size="small">
              <el-input clearable
                        :placeholder="`${$t('platformList.add.inputPlaceholder')}${$t('platformList.add.sort')}`"
                        size="small"
                        v-model="editForm.sort">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('platformList.add.desc')"
                          size="small">
              <el-input clearable
                        :placeholder="`${$t('platformList.add.inputPlaceholder')}${$t('platformList.add.desc')}`"
                        size="small"
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        resize="none"
                        v-model.number="editForm.desc"
                        maxlength="200">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 type="primary"
                 @click="save"
                 :loading="loading">{{$t('platformList.add.save')}}</el-button>
      <el-button size="small"
                 @click="editVisible = false">{{$t('platformList.add.close')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { cmofferApi }  from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                name: "",
                sort: "",
                code: "",
                url: "",
                desc: "",
            },
            tableItem: {},
            loading: false,
        };
    },
    methods: {
        /**
         * 平台下拉列表获取
         */
        platform() {
            this.loading = true;
            cmofferApi.platform({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    this.editForm = res.data;
                    this.loading = false;
                }
            });
        },
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.editForm = {
                name: "",
                sort: "",
                code: "",
                url: "",
                desc: "",
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .platform(
                            { ...this.editForm },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent.platform();
                                this.closeDialog();
                                this.loading = false;
                            }
                        });
                }
            });
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
    },
    watch: {
        mixed: {
            handler(newValue) {
                if (newValue.editVisible) {
                    this.tableItem = newValue.tableItem;
                    this.platform();
                }
            },
            immediate: false,
            deep: true,
        },
    },
    computed: {
        mixed() {
            const { editVisible, tableItem } = this;
            return {
                tableItem,
                editVisible,
            };
        },
    },
};
</script>
<style lang="scss">
.edit {
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
}
</style>
